module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-500.6cd2107c.ttf";